









import Vue from 'vue';
import StormHeader from '@/components/StormHeader.vue';
import InformationSection from '@/components/InformationSection.vue';
import Buttons from '@/components/Buttons.vue';

export default Vue.extend({
  name: 'Home',

  components: {
    StormHeader,
    InformationSection,
    Buttons,
  },
});
